var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { class: { footer: true, mobile: _vm.isMobile(_vm.$mq) } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "Button",
        {
          staticClass: "button",
          attrs: { green: "" },
          on: { click: _vm.handleClick }
        },
        [_vm._v(" Gift now ")]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _c("span", { staticClass: "b-sprite-paywall-pix-gift-box3" }),
      _vm._v(
        "\n    The perfect gift to help them finish the day a little smarter.\n  "
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }